/** The date ranges an automation's run history can be filtered by. */
const RUN_HISTORY_DATE_FILTER_OPTIONS = Object.freeze([
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'lastSevenDays', label: 'Last 7 days' },
  { value: 'allTime', label: 'All time' }
]);

export default RUN_HISTORY_DATE_FILTER_OPTIONS;
